import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CopyFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CopyFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M20.51 5.805v9.95c0 2.62-2.12 4.74-4.74 4.74H5.81c.59 1.46 2.03 2.5 3.7 2.5h7.24c3.45 0 6.24-2.8 6.24-6.24v-7.24c0-1.67-1.03-3.1-2.49-3.7l.01-.01Z" />
          <path d="M14.51 1.005h-9.5a4 4 0 0 0-4 4v9.49a4 4 0 0 0 4 4h9.5a4 4 0 0 0 4-4v-9.49a4 4 0 0 0-4-4Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default CopyFilled;